import { SxProps, Theme } from "@mui/material";
import { EventToCompare } from "../../../models/Event";

export const getGridTemplateColumns = ({
	showAction,
	showChangedFields,
}: {
	showAction: boolean;
	showChangedFields: boolean;
}) => {
	if (showAction && showChangedFields) {
		return "0.3fr 0.7fr 1.2fr 1.2fr 1fr 1fr 1fr 1.5fr 0.3fr";
	}
	if (showAction) {
		return "0.6fr 1.2fr 1fr 1fr 1fr 1fr";
	}
	if (showChangedFields) {
		return "0.5fr 1.2fr 1.2fr 1fr 1fr 1fr 1.5fr";
	}
	return "1.2fr 1.2fr 1fr 1fr 1fr";
};

export const gridRowSx: SxProps<Theme> = {
	display: "grid",
	gap: 2,
	py: 0.5,
	px: 1.5,
	alignItems: "center",
};

export const GROUP_COLORS = [
	"#2196F3", // Blue
	"#9C27B0", // Purple
	"#FF9800", // Orange
	"#009688", // Teal
	"#795548", // Brown
	"#607D8B", // Blue Grey
	"#E91E63", // Pink
	"#00BCD4", // Cyan
];

export const ACTION_COLORS = [
	{ color: "#4CAF50", name: "created", code: "C" }, // Green - Created
	{ color: "#F44336", name: "deleted", code: "D" }, // Red - Deleted
	{ color: "#FF9800", name: "updated", code: "U" }, // Orange - Updated (will be overridden by group color)
	{ color: "#4fb2ff", name: "moved", code: "M" }, // Orange - Updated (will be overridden by group color)
	{ color: "grey.400", name: "unchanged", code: "X" },
];

export const getEventBorderColor = (event: EventToCompare): string => {
	if (event.ActionTypeCode === "C")
		return ACTION_COLORS.find((color) => color.code === "C")!.color;
	if (event.ActionTypeCode === "D")
		return ACTION_COLORS.find((color) => color.code === "D")!.color;
	if (event.GroupId !== null) return getGroupColor(event.GroupId);
	return "transparent";
};

export const getGroupColor = (groupId: number | null): string => {
	if (groupId === null) return "transparent";
	return GROUP_COLORS[(groupId - 1) % GROUP_COLORS.length];
};
